@if(enablePage.showukOrdersLeftSection){
<div >
<div class="orders_viewdiff d-none" id="backbtn" (click)="backbtn()"><div class="global_blackarrow mobileorder"></div>Select Different Order </div>

<div class="col-xs-12">
    <div class="orderheaderseason">{{dropdownValue.replace('-20','/')}}
        Season</div>
    <div class="orderseasonsubheader">{{"ukmyorder.message" | cxTranslate}}</div>
</div>
<div class="col-lg-5 col-md-5 col-sm-12 col-12 open-order float_left" id="leftsection">

  
    <div class="form-group">
        <div class="col-md-8 col-lg-8 col-sm-8 col-8 no-padding for_tab_view float_left">
            <div class="input-group seach_order">
                <div class="input-group-addon">
                    <i class="fa fa-search"></i>
                </div>
                <input (keyup)="inputsearch($event);applyFilter()" class="form-control" id="open_order_search" name="lookup" type="text"  [(ngModel)]="valformsummary">
            </div>
        </div>
                     <div class="col-md-1 col-2 filterbox float_left"  (click)="filteropen()">
            <span class="select_counter">{{count}}</span><span class="filter_txt">{{"ukmyorder.filterlabel" | cxTranslate}}</span>
        </div>
        <div class="col-md-1 col-2 sortbox float_left" (click)="sortopen()" [ngClass]="togglesortView?'open':''"> <span class="filter_txt">{{"ukmyorder.sortlabel" | cxTranslate}}</span></div>
    
         
        <div class="filteropen" (click)="onFilterClick($event)" [ngClass]="togglefilterView?'open':''">
            <div class="prodsection">
                <div class="filterheader">{{"myorder.byproductlabel" | cxTranslate}}</div>
                @for( item of getfilterdata?.seqirusProductList; track item;let i=$index){
                <div class="col-md-12 no-padding">
                <label > <input type="checkbox" class="registration_checkbox" [checked]="filterValues.filterbyproduct.includes(item)"  value={{item}}   (click)="incrementcountproduct($event,i);applyFilter()"> <span class="checkbox-button__control"></span>{{item}}</label>
            </div>  
        }
                    </div>
            <div class="statussection">
                <div class="filterheader">{{"myorder.bystatuslabel" | cxTranslate}}</div>
                <div >
                    @for(list of getstatus?.seqirusOrderStatusList;track list;let i=$index){
                    <div class="col-md-12 no-padding">
                        <label> <input type="checkbox" class="registration_checkbox"  value={{list}}  (click)="incrementcountstatus($event,i);applyFilter()" [checked]="filterValues.filterbystatus.includes(list)"  > <span class="checkbox-button__control" ></span>{{list}}</label>
                    </div>
                }
                    
                </div>
                
              
            </div>
            <div
        class="invoice_reset"
        id="invoice_resetfilter"
        (click)="resetFilter()"
      >
      {{"myorder.resetlabel" | cxTranslate}}
      </div>
        </div>
        <div class="sortopen" (click)="onFilterClick($event)" [ngClass]="togglesortView?'open':''">
            <div class="sortcont">
            <div >
                <div class="col-md-6 no-padding floatleftuk">
                    <div class="filterheader">{{"myorder.ordernumlabel" | cxTranslate}}</div>
                    <label> <input type="radio" class="registration_radio" name="radiobtn" value="1to9" (click)="sortTest('1to9')" [checked]="sortvalue=='1to9'?'checked':''"> <span class="radio-button__control" ></span>{{"myorder.1to9label" | cxTranslate}}</label> <label> <input type="radio" class="registration_radio" name="radiobtn" value="9to1" (click)="sortTest('9to1')" [checked]="sortvalue=='9to1'?'checked':''"> <span class="radio-button__control"></span>{{"myorder.9to1label" | cxTranslate}}</label>
                </div>
                <div class="col-md-6 no-padding floatleftuk">
                    <div class="filterheader">{{"myorder.loclabel" | cxTranslate}}</div>
                    <label> <input type="radio" class="registration_radio" name="radiobtn" value="AtoZ" (click)="sortTest('AtoZ')" [checked]="sortvalue=='AtoZ'?'checked':''"> <span class="radio-button__control"></span>{{"myorder.atozlabel" | cxTranslate}}</label> <label> <input type="radio" class="registration_radio" name="radiobtn" value="ZtoA" (click)="sortTest('ZtoA')" [checked]="sortvalue=='ZtoA'?'checked':''"> <span class="radio-button__control"></span>{{"myorder.ztoalabel" | cxTranslate}}</label>
    
                </div>
            </div>
            <br>
            <div >
                <div class="col-md-12 floatleftuk no-padding">
                    <div class="filterheader">{{"myorder.dateplacedlabel" | cxTranslate}}</div>
                    <label> <input type="radio" class="registration_radio" name="radiobtn" value="MostRecent" (click)="sortTest('MostRecent')" [checked]="sortvalue=='MostRecent'?'checked':''"> <span class="radio-button__control"></span>{{"myorder.mostreclabel" | cxTranslate}}</label> <label> <input type="radio" class="registration_radio" name="radiobtn" value="LeastRecent" (click)="sortTest('LeastRecent')" [checked]="sortvalue=='LeastRecent'?'checked':''"> <span class="radio-button__control"></span>{{"myorder.leastreclabel" | cxTranslate}}</label>
    
    
                </div>
            </div>
        </div>
            <div
            class="invoice_reset "
            id="invoice_resetfilter"
            (click)="resetsort()"
          >
          {{"myorder.resetlabel" | cxTranslate}}
          </div>
           
        </div>
       
        
    </div>
    
    <div class="clearfix"></div>
    
    <hr>
    @if(isLoading){
    <div  class="loading">
        <div class="loading_txt">
        <div class="load_txt">{{"myorder.loadinglabel" | cxTranslate}}</div>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
}
@if(!isLoading){
     <div >
   
    <div class="mat-elevation-z8 " id="orderfiltertable">
        <mat-form-field class="mattablesearch">
          <mat-label>{{"ukmyorder.filterlabel" | cxTranslate}}</mat-label>
          <input matInput (keyup)="inputsearch($event);applyFilter()" placeholder="Search, filter, or sort your orders">
        </mat-form-field>
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        
    
     <ng-container matColumnDef="combined" >
 <th class="odertableheader" mat-header-cell *matHeaderCellDef> order Data </th>
      <td mat-cell *matCellDef="let element" (click)="openrightsectio(element.orderId,dropdownValue)"> 
        <div class="tablecolum_order1">
         <span>{{element.season}} SEASON</span>
        <div class="order_id">{{"ukmyorder.orderno" | cxTranslate}} {{element.orderId}}</div>
        <div class="order_unit"><span class="left-font">{{"ukmyorder.placedon" | cxTranslate}}</span><span class="totalorderquantity_Order left-font" [className]=element.orderId>{{element.orderDate}}</span></div>
        <div class="order_unit"><span class="left-font">{{element.displayProduct1}}</span><span class="totalorderquantity_Order left-font" [className]=element.orderId>{{element.aqivTotal | number:'1.0-0'}}</span></div>
        <div class="order_unit"><span class="left-font">{{element.displayProduct2}}</span><span class="totalorderquantity_Order left-font" [className]=element.orderId>{{element.qivcTotal | number:'1.0-0'}}</span></div>
        <div class="order_location "><span class="left-font">{{"ukmyorder.delivloc" | cxTranslate}}</span>
            <span class="order_substaus">
            {{element.delLocation}}</span>
        </div>
        </div>
        <div class="order_status" [ngClass]="[ element.status?.includes('Pending')? 'status_ord_pending': element.status?.toLowerCase().includes('hold')? 'onholdstatus': 'status_ord_complete',element.status?.toLowerCase() === 'on hold'? 'status_on_onhold': '']">{{element.status}}</div>
        </td>
          
 
      </ng-container>
      
          
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row id="{{row.orderId}}" *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row " *matNoDataRow>
            <td class="mat-cell no-matching">{{"myorder.nodatamsg" | cxTranslate}}</td>
          </tr>
        </table>
   
   <div class="custom-paginator" *ngIf="dataSource.length!=0">
    <button class="pagination-buttonOrg" (click)="goToFirstPage()" [disabled]="isFirstPage()">
      <img alt="Navigate to previous page" src="assets/images/pagination-double-prev-arrow-icon.svg" class="locations_arrows">
    </button>
    <button class="pagination-buttonOrg" (click)="previousPage()" [disabled]="isFirstPage()">
      <img alt="Navigate to previous page" src="assets/images/pagination-prev-btn.svg" class="locations_arrows">
    </button>
    @for( pge of getPages();track pge){
    <button class="pagination-buttonOrg"  [class.active-page]="isCurrentPage(pge)" (click)="goToPage(pge)">
      {{pge}}
    </button>
}
    <button class="pagination-buttonOrg" (click)="nextPage()" [disabled]="isLastPage()">
      <img alt="Navigate to next page" src="assets/images/pagination-next-btn.svg" class="locations_arrows">
    </button>
    <button class="pagination-buttonOrg" (click)="goToLastPage()" [disabled]="isLastPage()">
      <img alt="Navigate to last page" src="assets/images/pagination-double-next-arrow-icon.svg" class="locations_arrows">
    </button>
    </div>  
 </div>
    </div>
}
    </div>


    
    @if(rightisLoading){
    <div  class="loading">
        <div class="loading_txt">
        <div class="load_txt">{{"myorder.loadinglabel" | cxTranslate}}</div>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
}
    <div class="mobileright"  id="rightsection">
        @if(!rightisLoading && firstvalue){
    <div >
    <div class="col-lg-7 col-md-7 col-span-12 right-order  order-details-view float_left ">
      
      @if(rightsectionresponse){
        <!-- {{rightsectionresponse | json}} -->
        <!-- {{rightsectionresponse.seasonData[0].orderId}} -->
        <div class="order_details_section col-md-12" id="{{rightsectionresponse.seasonData[0].orderId}}">
    
            <div class="order_status_table">
                <div class="row order_panel_header right-first-row">
                    <div class="col-md-4 col-xs-8 order_Id_Col">
                        <div class="order_id">
                            {{"ukmyorder.orderno" | cxTranslate}}<span class="order_id_fetch">{{rightsectionresponse.seasonData[0].orderId}}</span>
                            <!-- <span style="margin-left:20px">{{rightsectionresponse.seasonData[0].status}}</span> -->
                        </div>
                        
                    </div>
                    <div class="col-md-3 col-xs-4">
                        <div class="current_order_status">
                            {{rightsectionresponse.seasonData[0].status}}
                            <!-- <span style="margin-left:20px">{{rightsectionresponse.seasonData[0].status}}</span> -->
                        </div>
                        
                    </div>
                    @if(dropdownValue!=prepreseason){
                    <div class="col-md-5 button_wrap">
                    
                          @if(rightsectionresponse?.seasonData[0]?.confirmOrderClosed!=true && rightsectionresponse.orderingPermission=='MANAGE'){
                            @if(rightsectionresponse.seasonData[0].status == 'Order Pending Approval' || rightsectionresponse.seasonData[0].status == 'Amendment Pending Approval'){
                        <button class="order_button order_btn_grey confirmOrderBtn" (click)="handleOnConfirmOrderClick(rightsectionresponse.seasonData[0])" >{{"ukmyorder.confirmorderlabel" | cxTranslate}}</button>
                            }
                          }

                                    @if(rightsectionresponse?.seasonData[0]?.amendOrderClosed!=true && rightsectionresponse.orderingPermission=='MANAGE'){
                                        @if(rightsectionresponse.seasonData[0].status == 'Order Confirmed' || rightsectionresponse.seasonData[0].status == 'Amendment Confirmed' || rightsectionresponse.seasonData[0].status == 'Order Pending Approval' || rightsectionresponse.seasonData[0].status == 'Amendment Pending Approval'){
                                <button class="prepreamend"  (click)="handleOnAmendBtnClick(rightsectionresponse.seasonData[0])">
                                   Amend Order
                                    </button>
                                }
                                    }
                               
                                </div>
                            }
                            @if(dropdownValue==prepreseason){
                                <div class="col-md-5 button_wrap">
                    
                                   @if(rightsectionresponse?.seasonData[0]?.confirmOrderClosed!=true && rightsectionresponse.orderingPermission=='MANAGE' && !isAsAgent){
                                    @if(rightsectionresponse.seasonData[0].status == 'Order Pending Approval' || rightsectionresponse.seasonData[0].status == 'Amendment Pending Approval'){
                                <button class="order_button order_btn_grey confirmOrderBtn prepreconfirm" (click)="handleOnConfirmOrderClick(rightsectionresponse.seasonData[0])">{{"ukmyorder.confirmorderlabel" | cxTranslate}}</button>
                                    }
                                   }
                                            @if(rightsectionresponse?.seasonData[0]?.confirmOrderClosed!=true && rightsectionresponse.orderingPermission=='MANAGE' && isAsAgent){
                                                @if(rightsectionresponse.seasonData[0].status == 'Order Pending Approval' || rightsectionresponse.seasonData[0].status == 'Amendment Pending Approval'){
                                                <button class="order_button order_btn_grey resendlink" (click)="handleOnresendlink(rightsectionresponse.seasonData[0],$event)">Resend Confirmation Email</button>
                                                }
                                            }
        
                                           @if(rightsectionresponse?.seasonData[0]?.amendOrderClosed!=true && rightsectionresponse.orderingPermission=='MANAGE'){
                                            @if(rightsectionresponse.seasonData[0].status == 'Order Confirmed' || rightsectionresponse.seasonData[0].status == 'Amendment Confirmed' || rightsectionresponse.seasonData[0].status == 'Order Pending Approval' || rightsectionresponse.seasonData[0].status == 'Amendment Pending Approval'){
                                        <button  class="prepreamend" [ngClass]="isAsAgent?'asmprepre':''" (click)="handleOnAmendBtnClick(rightsectionresponse.seasonData[0])">
                                            Amend Pre-order
                                            </button>
                                        }
                                           }
                                       
                                        </div>
                                    }


                    <div class="col-md-12 contact_inst">
                        @if(rightsectionresponse.seasonData[0].status != 'Order Pending Approval' && rightsectionresponse.seasonData[0].status != 'Amendment Pending Approval'){
                        <div class="contact_order_txt" >
                            &nbsp;{{"ukmyorder.orderqstn" | cxTranslate}}
                            &nbsp;@if(preprebookcustomerservice=='True' || prebookcustomerservice=='True'){<a href="mailto:flu.salesuk@seqirus.com" title="Contact our Sales Team" target="_self">{{"ukmyorder.contactsalestxt" | cxTranslate}}</a>}
                            @else{<a href="mailto:service.uk@seqirus.com" title="Contact our Customer Service Team" target="_self">{{"ukmyorder.contactCustServicetxt" | cxTranslate}}</a>}
                        </div>
                    }
                    @if(rightsectionresponse.seasonData[0].status != 'Order Confirmed'&& rightsectionresponse.seasonData[0].status != 'Amendment Confirmed' &&  rightsectionresponse.seasonData[0].status !='Order Completed' &&  rightsectionresponse.seasonData[0].status?.toLowerCase() != 'on hold'){
                        <div class="contact_order_txt confirm_txt">

                            {{"ukmyorder.confirmordermsg" | cxTranslate}}</div>
                        }
                    </div>
                    <!-- <div class="col-md-7 col-5 button_wrap">
                            <div class="order_button edit_ord">
                                <span class="order_id_fetch">{{rightsectionresponse.seasonData[0].status}}</span>
                            </div>
                            
                     </div> -->
                </div>
                 
                    
              
                <div class="row order_panel_header" >
                    <div class="col-md-2 col-3">
                        <div class="order_status_header">{{"ukmyorder.placedonlabel" | cxTranslate}}</div>
                        <div class="order_substaus">
                            {{rightsectionresponse.seasonData[0].orderDate}}</div>
                    </div>
                    @if(prepreseason==dropdownValue){
                    <div class="col-md-1 col-3" ></div>
                    }
                    <div class="col-md-2 col-3">
                        <div class="order_status_header">{{"ukmyorder.ponumlabel" | cxTranslate}}
                        </div>
                        <div class="order_substaus">{{rightsectionresponse.seasonData[0].poNumber}}</div>
                    </div>
                    @if(prepreseason!=dropdownValue){
                    <div class="col-md-2 col-3" >
                        <div class="order_status_header">{{"ukmyorder.creditdayslabel" | cxTranslate}}</div>
                        
                    <div class="order_substaus">{{rightsectionresponse.seasonData[0].creditDays}}</div>
                    </div>
                }
                   @if(prepreseason!=dropdownValue){
                    <div class="col-md-1 col-3">
                        <div class="order_status_header">{{"ukmyorder.sorlabel" | cxTranslate}}</div>
                        <!-- <i class="fa fa-info tooltip-wrap" matTooltip="Refer to your orders form or return section">
                           </i> -->
                        <div class="order_substaus" >@if(rightsectionresponse.seasonData[0].sor){
                            {{rightsectionresponse.seasonData[0].sor | number}}%
                        }
                            @else{
                                NA
                            }</div>
                    </div>
                }
                @if(prepreseason==dropdownValue){
                    <div class="col-md-1 col-3"></div>
                }
                    <div class="col-md-5 col-12 mobile_MT">
                        <div class="order_status_header">{{"ukmyorder.deladdrlabel" | cxTranslate}}</div>
                        <div class="order_substaus">
                           {{rightsectionresponse.seasonData[0].delLocation}}</div>
                    </div>
                </div>
    
                <div class="row order_panel_header no-border-B" >
                    @for( product of rightsectionresponse.seasonData[0].orderedandShippedProducts?.shipmentSummaryNonHistory;track product){
                    <div class="col-xs-12 col-md-6" > 
                        <div class="order_status_header quantity_header">
                            @if((dropdownValue == '2025-2026' || dropdownValue == '2026-2027' ) && product.fullProductName=='aQIV'){
                                {{"ukmyorder.ativ" | cxTranslate}}
                            }
                            @if(dropdownValue == preseason && product.fullProductName=='aQIV'){
                                Aujemflu
                            }
                            @if((dropdownValue == '2025-2026' || dropdownValue ==  '2026-2027' || dropdownValue == '2027-2028') && product.fullProductName=='QIVc'){
                                {{"ukmyorder.tivc" | cxTranslate}}
                            }
                            @if(dropdownValue != '2025-2026' && dropdownValue != '2026-2027' && dropdownValue != '2027-2028')
                            {{{product.fullProductName}}}
                            {{"ukmyorder.dosesdelivlabel" | cxTranslate}}</div>
                        <div class="order_substaus margin-T10 margin-B30">
                            <strong class="crnt-ord"><span class="crnt_order_qty">{{product.totalShippedQty | number:'1.0-0'}}</span>
                                units</strong> / <span class="total_qty total_qty0">{{product.totalOrderdQty | number:'1.0-0'}}</span>
                        </div>
                        <div class="progress progressUS progressUK">
                            <mat-progress-bar mode="determinate" value= {{getProgress(product.totalShippedQty,product.totalOrderdQty)}}></mat-progress-bar>
                        </div>                                            
                    </div>
                }
                    <!-- <div class="col-xs-12 col-md-6"> 
                        <div class="order_status_header quantity_header">QIVc QIVc Doses Delivered</div>
                        <div class="order_substaus margin-T10 margin-B30">
                            <strong class="crnt-ord"><span class="crnt_order_qty">{{rightsectionresponse.seasonData[0].aqivTotal}}</span>
                                units</strong> / <span class="total_qty total_qty0">{{rightsectionresponse.seasonData[0].qivcTotal}}</span>
                        </div>
                        <div class="progress progressUS">
                            <mat-progress-bar mode="determinate" value= {{getProgress(rightsectionresponse.seasonData[0].aqivTotal,rightsectionresponse.seasonData[0].qivcTotal)}}></mat-progress-bar>
                        </div>                                            
                    </div> -->
                    
                </div>
                <div class="order_panel_header no-padding-bottom product_Order_Details">
                    @if(dropdownValue!=prepreseason){
                    <table mat-table [dataSource]="dataSource2" multiTemplateDataRows class="table order-details-table">
                        <ng-container matColumnDef="baseProdName">
                            <th mat-header-cell *matHeaderCellDef>{{"ukmyorder.productlabel" | cxTranslate}}</th>
                            <td  mat-cell *matCellDef="let element"><span>{{element.baseProdName}}</span> </td>
                            <td mat-footer-cell *matFooterCellDef> {{"ukmyorder.totallabel" | cxTranslate}} </td>
                          </ng-container>
                          
                        <!-- Quantity Column -->
                        <ng-container matColumnDef="confirmedQty">
                            <th mat-header-cell *matHeaderCellDef> {{"ukmyorder.volumelabel" | cxTranslate}} </th>
                            <td mat-cell *matCellDef="let element"> <span class="ord_qty">{{element.quantityInDoses | number:'1.0-0'}}</span>&nbsp;doses<br> <i>(<span class="addComma">{{element.quantityInPacks}}</span>
                                packs)
                        </i> </td>
                            <td mat-footer-cell *matFooterCellDef="let this">{{getFinalDiscount() | number:'1.0-0'}} doses</td>
                          </ng-container>
                          <!-- Price Per Dose Column -->
                        <ng-container matColumnDef="listPrice" >
                            <th mat-header-cell *matHeaderCellDef> {{"ukmyorder.listpricelabel" | cxTranslate}} </th>
                            <td mat-cell *matCellDef="let element">{{element.listPrice | currency:'GBP':'symbol':'1.2-2'}} </td>
                            <td mat-footer-cell *matFooterCellDef [innerHTML]="'ukmyorder.totalpricelabel' | cxTranslate"></td>
                          </ng-container>
                           <!-- Total Price Column -->
                        <ng-container matColumnDef="perDosePrice">
                            <th mat-header-cell *matHeaderCellDef> {{"ukmyorder.perdosepricelabel" | cxTranslate}} </th>
                            <td class="delivery_status" mat-cell *matCellDef="let element"> {{element.perDosePrice | currency:'GBP':'symbol':'1.2-2'}} </td>
                            <td mat-footer-cell *matFooterCellDef>{{getTotalCost() | currency:'GBP':'symbol':'1.2-2'}}</td>
                          </ng-container>
                          
                          <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr> 
               
     <ng-container>
      <tr  mat-row *matRowDef="let row; columns:displayedColumns1;let i=index" [class.expanded-row]="row.expanded" ></tr>
    </ng-container> 
    <ng-container>
    <tr mat-footer-row *matFooterRowDef="displayedColumns1" class="example-second-footer-row">
    </tr>
</ng-container>
    
        <!-- <tr class="tabledetailrow" *matRowDef="let row; columns: [];  let i=index" [class.expanded-row]="row.expanded"> 
            <ng-container>

            <td  [attr.colspan]="4">

                <table class="totalTableClass">
                    <thead>
                        <tr>
                            <th class="order_total_row">Total</th>
                            <th class="order_total_row">{{this.finalDosesCount}}  doses</th>
                            <th class="order_total_row">Total Price<br> <span>(Excluding VAT)</span></th>
                            <th class="order_total_row">£ {{this.rightsectionresponse.seasonData[0].totalCost}}</th>
                        </tr>
                    </thead>
                    
                </table>
            </td>
        </ng-container>
    </tr>  -->
  
                       
                    </table>
                }
                @if(dropdownValue==prepreseason){
                    <table mat-table [dataSource]="dataSource2" multiTemplateDataRows class="table order-details-table prepretable" >
                        <ng-container matColumnDef="baseProdName">
                            <th mat-header-cell *matHeaderCellDef>{{"ukmyorder.productlabel" | cxTranslate}}</th>
                            <td  mat-cell *matCellDef="let element">
                                @if(prepreseason==dropdownValue && element.baseProdName=='aTIV 10 Pack'){
                                <span >aTIV (aIIV) 10 Pack</span>
                                }
                                @if(prepreseason==dropdownValue && element.baseProdName=='TIVc 10 Pack'){
                                <span >TIVc (IIVc) 10 Pack</span>
                                }
                            </td>
                            <td mat-footer-cell *matFooterCellDef> {{"ukmyorder.totallabel" | cxTranslate}} </td>
                          </ng-container>
                          
                        <!-- Quantity Column -->
                        <ng-container matColumnDef="confirmedQty">
                            <th mat-header-cell *matHeaderCellDef> {{"ukmyorder.volumelabel" | cxTranslate}} </th>
                            <td mat-cell *matCellDef="let element"> <span class="ord_qty">{{element.quantityInDoses | number:'1.0-0'}}</span>&nbsp;doses<br> <i>(<span class="addComma">{{element.quantityInPacks}}</span>
                                packs)
                        </i> </td>
                            <td mat-footer-cell *matFooterCellDef="let this">{{getFinalDiscount() | number:'1.0-0'}} doses</td>
                          </ng-container>
                          <!-- Price Per Dose Column -->
                          
                          <tr mat-header-row *matHeaderRowDef="prepredisplayedColumns1"></tr> 
               
     <ng-container>
      <tr  mat-row *matRowDef="let row; columns:prepredisplayedColumns1;let i=index" [class.expanded-row]="row.expanded" ></tr>
    </ng-container> 
    <ng-container>
    <tr mat-footer-row *matFooterRowDef="prepredisplayedColumns1" class="example-second-footer-row">
    </tr>
</ng-container>
    
        <!-- <tr class="tabledetailrow" *matRowDef="let row; columns: [];  let i=index" [class.expanded-row]="row.expanded"> 
            <ng-container>

            <td  [attr.colspan]="4">

                <table class="totalTableClass">
                    <thead>
                        <tr>
                            <th class="order_total_row">Total</th>
                            <th class="order_total_row">{{this.finalDosesCount}}  doses</th>
                            <th class="order_total_row">Total Price<br> <span>(Excluding VAT)</span></th>
                            <th class="order_total_row">£ {{this.rightsectionresponse.seasonData[0].totalCost}}</th>
                        </tr>
                    </thead>
                    
                </table>
            </td>
        </ng-container>
    </tr>  -->
  
                       
                    </table>
                }
                    
                </div>  
                <div class="row order_panel_header">
                    <div class="col-md-12 order_id margin-T20 orderdelivery">
                        {{"ukmyorder.delivcalendar" | cxTranslate}}</div>
                    <div class="col-md-12 orders_locationprodtxt margin-L10">
                        {{"ukmyorder.deliverymsg" | cxTranslate}}</div>
@if(deliveriesTable?.data[0]?.detailedStatus == 'Planned'){
                    <div class="col-md-12 scheduled_del">
                        <div class="col-xs-12 col-md-12 orders_nextdeliverble">{{"ukmyorder.schdeliverydate" | cxTranslate}}</div>
                        <div class="col-xs-12 col-md-12 orders_monthdelverytxt">{{deliveriesTable?.data[0].deliveryDate}}</div>
                                <div class="col-xs-12 col-md-12 orders_nextdeliverble margin-T20 margin-B10">
                                    {{"ukmyorder.products" | cxTranslate}}</div>                          
                                <div class="col-md-12 total_product_delivery_first">
                                    @if(rightsectionresponse.seasonData[0].aqivTotal > 0){
                                    <span class="addComma">{{rightsectionresponse.seasonData[0].aqivTotal | number:'1.0-0'}}</span>
                                    }@else{
                                        <span class="addComma">0</span>
                                    }
                                    &nbsp; doses&nbsp; 
                                    {{deliveriesTable.data[0].displayProduct1}}
                                    @if(dropdownValue==prepreseason){
                                    <span >(aIIV)</span> 
                                    }
                                    <span class="gap_spacer"></span>
                                    @if(rightsectionresponse.seasonData[0].qivcTotal > 0){
                                    <span  class="addComma">{{rightsectionresponse.seasonData[0].qivcTotal | number:'1.0-0'}}</span>
                                    }
                                    @else{
                                        <span class="addComma">0</span>
                                    }
                                    &nbsp; doses&nbsp; 
                                    {{deliveriesTable.data[0].displayProduct2}}
                                    @if(dropdownValue==prepreseason){
                                    <span >(IIVc)</span>
                                    }
                                     <span class="gap_spacer"></span>
                                </div>
                        </div>
                    }
                    @if(deliveriesTable?.data[0]?.detailedStatus == 'Delivered'){
                        <div class="col-md-12 scheduled_del">
                            <div class="col-xs-12 col-md-12 orders_nextdeliverble">{{"ukmyorder.delivcompleted" | cxTranslate}}</div>
                                    </div>
                                }
                       
<div class="row order_details_cal">
    <div class="orders_monthtxt month_duration">
        August &nbsp;{{inSeason?.substr(0,4)}}&nbsp; - March &nbsp;20{{inSeason?.substr(5,7)}}
    </div>
    <div class="col-xs-12 col-md-12 margin-T20 no-padding calender_wrapper">
       

    <div class="col-12 calendar0">
  
                        <full-calendar class=" "  #calendar
                        [options]="calendarOptions0"
                        [deepChangeDetection]="true"
                        [events]="all_events"
                        id="mxCalendar1"
                      ></full-calendar>
                    </div>
                    <div class="col-12 calendar1">
                      <full-calendar  class="" #calendar1
                      [options]="calendarOptions1"
                      [deepChangeDetection]="true"
                      [events]="all_events"
                      id="mxCalendar2"
                    ></full-calendar> 
                </div>
                <div class="col-12 calendar2">
                    <full-calendar  class=" "  #calendar2
                    [options]="calendarOptions2"
                    [deepChangeDetection]="true"
                    [events]="all_events"
                    id="mxCalendar3"
                  ></full-calendar>
                </div>
                </div>
                <div class="col-md-12 order-details-calenderindicator">
                    <div class="order-details-calenderschedule">
                        <div class="order-details-calenderdeliveredcircle"></div>
                        <div class="order-details-calenderdeliveredname">
                            {{"ukmyorder.deliveredlabel" | cxTranslate}}</div>
                    </div>
                    <div class="order-details-calenderschedule">
                        <div class="order-details-calenderdeliveredsquare"></div>
                        <div class="order-details-calenderdeliveredname">
                            {{"ukmyorder.schdeliverydate" | cxTranslate}}</div>
                    </div>
                    <div class="order-details-calenderschedule">
                        <div class="order-details-calenderdeliveredsquareoval"></div>
                        <div class="order-details-calenderdeliveredname">
                            {{"ukmyorder.planneddelwndow" | cxTranslate}}</div>
                    </div>

                </div> 
            </div>
                <!-- <div
                class="col-xs-12 col-md-12 margin-T20 no-padding calender_wrapper">
                <div id="openorder_calendar0_{{rightsectionresponse.seasonData[0].orderId}}"
                    class="col-xs-12 order_details_cal calendar0"><full-calendar id class="calendar0"  #calendar
                    [options]="calendarOptions0"
                    id="mxCalendar"
                  ></full-calendar></div>
                <div id="openorder_calendar1_{{rightsectionresponse.seasonData[0].orderId}}"
                    class="col-xs-12 order_details_cal calendar1">
                    <full-calendar  class="calendar1" #calendar1
                    [options]="calendarOptions1"
                    id="mxCalendar"
                  ></full-calendar></div>
                <div id="openorder_calendar2_{{rightsectionresponse.seasonData[0].orderId}}"
                    class="col-xs-12 order_details_cal calendar2">
                    <full-calendar  class="calendar2"  #calendar2
                    [options]="calendarOptions2"
                    id="mxCalendar"
                  ></full-calendar>
                </div>
            </div> -->
           
               
                </div>
                





                <div class=" order_panel_header">
                    <div class="col-md-12  deliveriesClass order_id">
                        {{"ukmyorder.deliveries" | cxTranslate}}</div>
                    <div class="col-md-12 no-padding order_Id_Table">
                        <div id="openordershipmenttable_{{rightsectionresponse.seasonData[0].orderId}}_wrapper" class="dataTables_wrapper shipping_history no-footer">
                            <!-- <table id="openordershipmenttable_0010465981" class="display table order-details-table shipping_history dataTable" role="grid">
                        <thead>
                            <tr role="row"><th class="sorting_disabled" rowspan="1" colspan="1"></th></tr>
                        </thead><tbody><tr role="row"><td>
                        <div class="delivery_customNew"><span>Status</span><span>Scheduled</span></div>
                        <div class="delivery_customNew deliverySecond"><span>Expected Delivery Date</span><span>28/11/22</span></div>
                        <div class="delivery_customNew"><span>aQIV  Volume</span><span>(10 doses)<br>(1 packs)</span></div>
                        <div class="delivery_customNew"><span>QIVc  Volume</span><span> (0 doses)<br>(0 packs)</span></div>
                        <div class="delivery_customNew"><span>Track Delivery</span><span class="deliveryTrackingLink"><a target="_blank" href="https://preprod-portal.alloga.co.uk/csl-seqirus/startup.php?order_id=0080487492"><i class="global_blackarrow"></i></a></span></div></td></tr>
                    </tbody></table> -->
                    <table mat-table  class="table order-details-table" [dataSource]="dataSource4" >
                        
                        <ng-container matColumnDef="detailedStatus">
                          <th mat-header-cell *matHeaderCellDef> {{"ukmyorder.statuslabel" | cxTranslate}} </th>
                          <td mat-cell *matCellDef="let element"> {{element.detailedStatus}} </td>
                        </ng-container>
                      
                        <ng-container matColumnDef="deliveryDate">
                          <th mat-header-cell *matHeaderCellDef> {{"ukmyorder.expdelivdate" | cxTranslate}} </th>
                          <td mat-cell *matCellDef="let element"> {{element.deliveryDate}} </td>
                        </ng-container>
                      
                        <ng-container matColumnDef="volume1">
                          <th mat-header-cell *matHeaderCellDef>@if(seasonValue=='2025-2026' || seasonValue=='2026-2027' || seasonValue=='2027-2028'){ 
                            @if(dropdownValue!=prepreseason && dropdownValue!=preseason){<span >{{"ukmyorder.ativvol" | cxTranslate}}</span>}
                             @if(dropdownValue==prepreseason){<span>aTIV (aIIV) Volume</span>}}@else{{{"ukmyorder.aqivvol" | cxTranslate}}}
                            @if(dropdownValue==preseason){
                             <span>Aujemflu Volume</span>
                            }
                        </th>
                          <td mat-cell *matCellDef="let element"> <span [innerHTML]="element.volume1"></span> </td>
                        </ng-container>
                      
                        <ng-container matColumnDef="volume2">
                          <th mat-header-cell *matHeaderCellDef>@if(seasonValue=='2025-2026'|| seasonValue=='2026-2027' || seasonValue=='2027-2028'){@if(dropdownValue!=prepreseason){<span >{{"ukmyorder.tivcvol" | cxTranslate}}</span>}@if(dropdownValue==prepreseason){<span>TIVc (IIVc) Volume</span>}} @else{{{"ukmyorder.qivcvol" | cxTranslate}}} </th>
                          <td mat-cell *matCellDef="let element"> <span [innerHTML]="element.volume2"></span> </td>
                        </ng-container>
                      @if(showTrackingLink()){
                        <ng-container   matColumnDef="orderedDose">
                            <th mat-header-cell *matHeaderCellDef> {{"ukmyorder.trackdelivery" | cxTranslate}} </th>
                          <td mat-cell *matCellDef="let element">
                            @if(element.trackDelivery){
                            <a  [href]="element.trackDelivery" target="_blank"><i class="global_blackarrow"></i></a>
                            }
                          </td>
                        </ng-container>
                    }
                      
                        <tr mat-header-row *matHeaderRowDef="displayproduct"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayproduct;"></tr>
                      </table>
                </div>
                    </div>
                </div>
    

            </div> 
        </div>
        
      }
    </div>
</div>
        }
</div>
</div>
}
<!-- <div *ngIf="enablePage.showukCartReviewSection">
    <app-orders-cart-review-page></app-orders-cart-review-page>
</div>    -->
